import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { getListUsers, updateUser } from './shared/api/user';
import { useState, useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';

export default function BasicTable() {
  const navigate = useNavigate();
  const [users, setUSers] = useState([]);
  const [offset, setOffset] = useState(0);

  const init = async () => {
    let rows = await getListUsers('CHEF', 10, offset);
    setUSers(rows.data.users)
  }

  const showChefOrders = () => {
    navigate("/");
  };

  const editUser = (id) => {
    navigate(`/user/edit/${id}`);
  };

  useEffect(() => {
    init();
  }, []);

  const updateUserDate = async (id, approval) => {
    await updateUser(id, { isApproved: approval });
    init();
  };

  async function paginationClickedNext() {
    setOffset(offset + 10);
    init();
  }

  async function paginationClickedPrev() {
    if (offset > 0) {
      setOffset(offset - 10);
      init();
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell align="right">Name</TableCell>
            <TableCell align="right">Phone</TableCell>
            <TableCell align="right">Ratings</TableCell>
            <TableCell align="right">Device</TableCell>
            <TableCell align="right">Orders</TableCell>
            <TableCell align="right">Edit Chef</TableCell>
            <TableCell align="right">Delete Chef</TableCell>
            <TableCell align="right">Approval</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((row) => (
            <TableRow
              key={row?.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row?.email}
              </TableCell>
              <TableCell align="right">{row?.firstName} {row?.lastName}</TableCell>
              <TableCell align="right">{row?.phoneNumber}</TableCell>
              <TableCell align="right">{row?.rating}</TableCell>
              <TableCell align="right">{row?.deviceType}</TableCell>
              <TableCell align="right"><Button sx={{ color: '#CB2704' }} variant="text"><RestaurantIcon></RestaurantIcon></Button></TableCell>
              <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => editUser(row._id)} variant="text"><EditIcon></EditIcon></Button></TableCell>
              <TableCell align="right"><Button sx={{ color: '#CB2704' }} variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
              {row.isApproved === false ? (
                <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => updateUserDate(row._id, true)} variant="text"><CheckIcon></CheckIcon></Button></TableCell>
              ) : (
                <TableCell align="right"><Button sx={{ color: '#CB2704' }} onClick={() => updateUserDate(row._id, false)} variant="text"><CloseIcon></CloseIcon></Button></TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box textAlign='center'>
        <Button sx={{ color: '#CB2704' }} onClick={() => paginationClickedNext()} variant="text">Load next</Button>
        {offset > 0 && <Button sx={{ color: '#CB2704' }} onClick={() => paginationClickedPrev()} variant="text">Load previous</Button>}
      </Box>
    </TableContainer>
  );
}